var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    rx: 5,
    fill: "#E7AB3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8412 9.46267C14.6339 8.28577 16.3661 8.28576 17.1588 9.46267L22.4935 17.3827C23.3883 18.7111 22.4364 20.5 20.8347 20.5H10.1653C8.56357 20.5 7.61167 18.7111 8.50648 17.3827L13.8412 9.46267Z",
    fill: "#FEFCF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9625 13L15.8813 15.7657H15.1188L15.0354 13H15.9625ZM15.5 17C15.3625 17 15.2445 16.955 15.1459 16.865C15.0472 16.7737 14.9986 16.6644 15 16.5371C14.9986 16.4111 15.0472 16.3031 15.1459 16.2131C15.2445 16.1231 15.3625 16.0781 15.5 16.0781C15.632 16.0781 15.7479 16.1231 15.8479 16.2131C15.9479 16.3031 15.9986 16.4111 16 16.5371C15.9986 16.622 15.9743 16.6998 15.9271 16.7705C15.8813 16.8399 15.8208 16.8959 15.7458 16.9383C15.6708 16.9794 15.5889 17 15.5 17Z",
    fill: "#E7AB3B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningIcon);
export default __webpack_public_path__ + "static/media/alert_warning_icon.3caff130c13e0e7f784d227175b1200d.svg";
export { ForwardRef as ReactComponent };